import { amplitude } from "@wb/ui/analytics/amplitude";
import { state } from "@wb/ui/analytics/state";
import { type FC, useEffect } from "react";
import { z } from "zod";

const schema = z.object({
  id: z.string(),
});

type Props = z.infer<typeof schema>;

export const AmplitudeAnalytics: FC<Props> = ({ id }) => {
  useEffect(() => {
    state.instances.push(amplitude);
  }, []);

  return (
    <>
      <script src={`https://cdn.amplitude.com/script/${id}.js`}></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
        window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 0.05 }));
        window.amplitude.init('${id}', {
          fetchRemoteConfig: true,
          autocapture: true,
        });
      `,
        }}
      />
    </>
  );
};
